/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { LEGACY_RUNTIME_IMAGE } from '../../constants/RuntimeImage.constants';
import { CreateJobManifestRequest } from '../JobManifestTypes';

export const createMockCreateJobManifestRequest = (
  partialRecord: Partial<CreateJobManifestRequest> = {},
): CreateJobManifestRequest => {
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');
  const input = {};

  return {
    concurrency: faker.number.int(),
    entryFile: faker.system.fileName(),
    entryFunction: {
      name: faker.lorem.word(),
      entry: faker.system.filePath(),
      input,
    },
    name: faker.lorem.word(),
    version,
    timeoutSeconds: faker.number.int({ max: 28800, min: 5 }),
    image: LEGACY_RUNTIME_IMAGE,
    autoRetry: false,
    ...partialRecord,
  };
};
